import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import CustomTypes from '../../types';

import { CardOptionStyled } from './CardOption.styled';

const CardOption = ({
  children,
  modifiers,
  checked,
  name,
  value,
}) => (
  <CardOptionStyled modifiers={modifiers}>
    <Field value={value} type="radio" checked={checked} name={name} />
    <span>{children}</span>
  </CardOptionStyled>
);

export default CardOption;

CardOption.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  modifiers: CustomTypes.oneOrMore(['', 'wBorder', 'active']),
  children: PropTypes.node,
};

CardOption.defaultProps = {
  checked: '',
  modifiers: '',
  children: '',
  value: '',
};
